import { theme } from "themes/default/theme"

export const styles = {
  uploadBox: {
    position: "fixed",
    width: 250,
    height: 75,
    zIndex: 2000,
    bottom: 20,
    right: 50,
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.25)",
    borderRadius: 1,
    backgroundColor: theme.palette.common.white,
  },
  imageBox: {
    position: "absolute",
    right: -50,
    bottom: -5,
  },
  progressBox: {
    width: 190,
    textAlign: "center",
    height: "100%",
    p: 1,
    flexWrap: "wrap",
  },
  infoText: {
    width: `calc(100% - 50px)`,
    fontSize: 14,
  },
}
